import { useMutation } from '@apollo/react-hooks';
import {
  SetDiscussionMessagesSeen,
  SetDiscussionMessagesSeenVariables,
} from '../../graphql/discussion/types/SetDiscussionMessagesSeen';
import { SET_DISCUSSION_MESSAGES_SEEN } from '../../graphql/discussion/mutation';

export const useSetDiscussionMessagesSeen = () => {
  return useMutation<
    SetDiscussionMessagesSeen,
    SetDiscussionMessagesSeenVariables
  >(SET_DISCUSSION_MESSAGES_SEEN, {
    onError: () => {
      // TODO: implement me
    },
  });
};
